import PropTypes from "prop-types";

/**
 *
 * @param {string} width
 * @param {string} height
 * @param {string} fill
 * @returns {JSX.Element}
 * @constructor
 */
export default function TV({ height = '14', width = '14', fill = 'none' }) {
    return (
        <svg width={width} height={height} viewBox="0 0 14 14" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M11.6663 0.333374H2.33301C1.80257 0.333374 1.29387 0.544088 0.918794 0.919161C0.543722 1.29423 0.333008 1.80294 0.333008 2.33337V9.00004C0.333008 9.53047 0.543722 10.0392 0.918794 10.4143C1.29387 10.7893 1.80257 11 2.33301 11H4.33301V12.3334H2.33301C2.1562 12.3334 1.98663 12.4036 1.8616 12.5286C1.73658 12.6537 1.66634 12.8232 1.66634 13C1.66634 13.1769 1.73658 13.3464 1.8616 13.4714C1.98663 13.5965 2.1562 13.6667 2.33301 13.6667H11.6663C11.8432 13.6667 12.0127 13.5965 12.1377 13.4714C12.2628 13.3464 12.333 13.1769 12.333 13C12.333 12.8232 12.2628 12.6537 12.1377 12.5286C12.0127 12.4036 11.8432 12.3334 11.6663 12.3334H9.66634V11H11.6663C12.1968 11 12.7055 10.7893 13.0806 10.4143C13.4556 10.0392 13.6663 9.53047 13.6663 9.00004V2.33337C13.6663 1.80294 13.4556 1.29423 13.0806 0.919161C12.7055 0.544088 12.1968 0.333374 11.6663 0.333374ZM8.33301 12.3334H5.66634V11H8.33301V12.3334ZM12.333 9.00004C12.333 9.17685 12.2628 9.34642 12.1377 9.47145C12.0127 9.59647 11.8432 9.66671 11.6663 9.66671H2.33301C2.1562 9.66671 1.98663 9.59647 1.8616 9.47145C1.73658 9.34642 1.66634 9.17685 1.66634 9.00004V8.33337H12.333V9.00004ZM12.333 7.00004H1.66634V2.33337C1.66634 2.15656 1.73658 1.98699 1.8616 1.86197C1.98663 1.73695 2.1562 1.66671 2.33301 1.66671H11.6663C11.8432 1.66671 12.0127 1.73695 12.1377 1.86197C12.2628 1.98699 12.333 2.15656 12.333 2.33337V7.00004Z" fill="black"/>
        </svg>
    )
}

TV.PropTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
}
